var _defs, _style, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem10C(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 289",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 414.25,
    cy: 440.85,
    r: 19.525,
    gradientTransform: "matrix(1.1761 0 0 -1.1761 -97.5 767.13)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 414.25,
    cy: 440.85,
    r: 19.525,
    gradientTransform: "matrix(1.1761 0 0 -1.1761 75.45 699.13)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 414.25,
    cy: 440.85,
    r: 19.525,
    gradientTransform: "matrix(1.1761 0 0 -1.1761 247.9 632.13)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 366.72,
    cy: 348.22,
    r: 21.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.106
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F8F8F",
    offset: 0.667
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 483.67,
    cy: 302.72,
    r: 21.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.106
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F8F8F",
    offset: 0.667
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "o",
    cx: 539.67,
    cy: 280.22,
    r: 21.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.106
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F8F8F",
    offset: 0.667
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: 656.62,
    cy: 234.73,
    r: 21.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.106
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F8F8F",
    offset: 0.667
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 712.12,
    cy: 213.22,
    r: 21.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.106
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F8F8F",
    offset: 0.667
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 829.08,
    cy: 167.72,
    r: 21.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.106
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F8F8F",
    offset: 0.667
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 225.37,
    x2: 345.79,
    y1: 413,
    y2: 413,
    gradientTransform: "rotate(-21.029)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.506
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 411.2,
    x2: 531.62,
    y1: 411.61,
    y2: 411.61,
    gradientTransform: "rotate(-21.029)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.506
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 596.21,
    x2: 716.63,
    y1: 410.97,
    y2: 410.97,
    gradientTransform: "rotate(-21.029)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.506
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 192.02,
    x2: 378.13,
    y1: 456.59,
    y2: 456.59,
    gradientTransform: "rotate(-21.029)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.506
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 377.86,
    x2: 563.96,
    y1: 455.2,
    y2: 455.2,
    gradientTransform: "rotate(-21.029)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.506
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 562.86,
    x2: 748.97,
    y1: 454.57,
    y2: 454.57,
    gradientTransform: "rotate(-21.029)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.506
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bfbfbf",
    d: "M71.701 246.343h162.592l353.372-137.806h66.317v151.817H70.767v-14.011z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 3,
    strokeWidth: 2.00154,
    d: "M71.701 246.343h162.592l353.372-137.806h65.317"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.72 224.326c2.49-2.49 5.504-3.736 9.04-3.736s6.55 1.245 9.04 3.736c2.491 2.49 3.737 5.504 3.737 9.04 0 3.537-1.246 6.55-3.737 9.041-2.49 2.49-5.504 3.736-9.04 3.736s-6.55-1.245-9.04-3.736c-2.49-2.49-3.736-5.504-3.736-9.04 0-3.537 1.245-6.55 3.736-9.041zm5.771 6.405.9.033c.268 0 .434.067.501.2.089.112.122.334.1.667v3.17c.022.355-.022.6-.133.734-.089.156-.29.244-.6.266l-.901.1v.467h4.837v-.467l-.834-.1c-.245-.022-.412-.066-.5-.133a.533.533 0 0 1-.234-.3 4.132 4.132 0 0 1-.034-.567v-5.238a14.93 14.93 0 0 1-1.568.433c-.489.112-1 .201-1.534.267z",
    fill: "#7493b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.491 230.73v-.466a15.681 15.681 0 0 0 1.534-.267c.512-.11 1.035-.256 1.568-.433v5.237c0 .223.012.412.034.568a.534.534 0 0 0 .233.3c.089.067.256.11.5.133l.835.1v.467h-4.837v-.467l.9-.1c.312-.022.512-.11.6-.266.112-.134.156-.379.134-.735v-3.169c.022-.334-.011-.556-.1-.667-.067-.134-.233-.2-.5-.2z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.348 177.223c3.536 0 6.549 1.245 9.04 3.736s3.737 5.504 3.737 9.041c0 3.536-1.246 6.55-3.737 9.04s-5.504 3.737-9.04 3.737-6.55-1.245-9.04-3.737-3.738-5.504-3.738-9.04c0-3.537 1.246-6.55 3.737-9.04s5.504-3.737 9.04-3.737z",
    fill: "#7493b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.215 187.264c.2.334.3.7.3 1.1 0 .445-.123.846-.367 1.202-.267.377-.7.756-1.3 1.134-.156.133-.334.29-.535.467-.222.155-.467.345-.734.567v.033h2.102c.267 0 .479-.01.634-.033a.938.938 0 0 0 .367-.233c.111-.112.222-.29.333-.535l.434.1-.467 1.935h-5.638v-.366c.312-.222.668-.467 1.068-.734a8.705 8.705 0 0 0 1.134-.9c.378-.334.679-.68.902-1.036.244-.377.366-.778.366-1.2a1.86 1.86 0 0 0-.133-.701c-.09-.2-.233-.367-.434-.5s-.455-.2-.766-.2c-.267 0-.512.066-.735.2a1.852 1.852 0 0 0-.567.433 4.28 4.28 0 0 0-.434.567l-.367-.3.834-1.234c.245-.267.534-.467.868-.6.311-.134.678-.212 1.1-.234.468.022.879.123 1.235.3.356.2.622.456.8.768z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.766 135.157c3.536 0 6.549 1.246 9.04 3.736 2.49 2.491 3.737 5.505 3.737 9.04s-1.246 6.55-3.737 9.041-5.504 3.736-9.04 3.736-6.55-1.245-9.04-3.736-3.737-5.504-3.737-9.04 1.245-6.55 3.737-9.04 5.504-3.737 9.04-3.737z",
    fill: "#7493b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.465 147.567c.377-.311.568-.7.568-1.168 0-.422-.112-.734-.334-.934a1.133 1.133 0 0 0-.834-.333 1.492 1.492 0 0 0-.868.333c-.244.2-.456.422-.633.667l-.334-.3.667-.9c.179-.223.423-.412.734-.568a3.057 3.057 0 0 1 1.035-.233c.667.022 1.19.2 1.568.534.378.355.578.822.6 1.4 0 .2-.044.379-.134.534-.088.156-.21.3-.367.434a2.44 2.44 0 0 1-.433.334 4.136 4.136 0 0 1-.567.4v.033c.445.067.822.2 1.134.4.311.223.544.479.7.768.179.311.267.634.267.967a3.04 3.04 0 0 1-.333 1.301c-.2.357-.467.679-.8.968-.334.267-.68.489-1.035.667s-.69.3-1 .367c-.29.089-.523.133-.701.133-.312 0-.59-.055-.834-.167-.267-.088-.467-.2-.6-.333a1.04 1.04 0 0 1-.2-.267.609.609 0 0 1 .032-.334c.022-.088.067-.178.134-.267s.145-.155.233-.2c.068-.066.134-.1.2-.1.09 0 .156.034.201.1.133.112.278.223.433.334.178.133.367.245.568.334.2.066.411.11.633.133.245 0 .479-.078.701-.234.2-.133.367-.344.5-.633.134-.29.201-.668.201-1.135 0-.445-.09-.812-.267-1.1a1.557 1.557 0 0 0-.6-.6 1.274 1.274 0 0 0-.734-.168c-.178 0-.345.012-.5.034s-.29.055-.4.1l-.134-.434c.666-.245 1.177-.534 1.533-.867z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.666 133.022c-1.357-2.223-3.313-3.714-5.871-4.47-1.001-.155-1.746-.233-2.236-.233a9.678 9.678 0 0 0-5.07 1.4c-2.268 1.513-3.725 3.47-4.37 5.872-.645 2.78-.256 5.215 1.167 7.305 1.468 2.247 3.425 3.715 5.872 4.404 1.045.2 1.868.3 2.468.3 1.868 0 3.48-.434 4.837-1.3 2.313-1.38 3.781-3.37 4.404-5.972.622-2.469.222-4.904-1.201-7.306zm-7.906-9.44c1.023 0 2.09.111 3.202.333 3.781 1.09 6.75 3.314 8.907 6.672 2.024 3.425 2.569 7.06 1.635 10.908-.868 3.759-3.014 6.728-6.439 8.907-2.446 1.401-4.926 2.102-7.439 2.102-1.067 0-2.235-.167-3.502-.5-3.915-.846-6.95-2.991-9.108-6.439-.356-.912-.69-1.656-1-2.235-1.046-2.78-1.257-5.682-.634-8.707.957-3.847 3.169-6.805 6.638-8.873 2.402-1.446 4.982-2.168 7.74-2.168z",
    fill: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.587 124.783c2.49-1.49 5.17-2.236 8.04-2.236 2 .2 3.224.345 3.669.434 4.18 1.201 7.317 3.547 9.407 7.039 1.601 2.468 2.357 5.149 2.268 8.04 0 1.378-.144 2.601-.433 3.669-1.046 4.048-3.436 7.227-7.173 9.54-2.357 1.624-4.96 2.37-7.806 2.236-1.29 0-2.58-.145-3.87-.434-3.936-1.045-7.083-3.403-9.44-7.072l-1.167-2.469c-.512-1.668-.834-3.491-.968-5.47.178-1.735.323-2.948.434-3.637 1.09-4.158 3.436-7.372 7.039-9.64zm8.04 4.636c-1.735 0-3.192.39-4.37 1.168-2.07 1.378-3.414 3.191-4.037 5.438-.267.6-.356 1.279-.267 2.034 0 1.668.4 3.136 1.2 4.404 1.18 1.935 2.992 3.214 5.438 3.836.89.178 1.568.267 2.035.267 1.535 0 3.003-.412 4.404-1.234 1.934-1.246 3.235-2.98 3.903-5.204.111-1.113.166-1.802.166-2.069 0-1.69-.389-3.146-1.167-4.37-1.112-2.068-2.858-3.436-5.238-4.103-.844-.2-1.534-.255-2.068-.167zm-5.638-.433c1.756-1.09 3.636-1.635 5.637-1.635.956 0 1.78.145 2.469.434 2.758.512 4.97 2.046 6.638 4.603 1.046 1.958 1.523 3.848 1.435 5.671 0 .512-.078 1.346-.234 2.502-.778 2.914-2.379 5.116-4.804 6.605-1.89.956-3.747 1.39-5.57 1.301-.579 0-1.446-.078-2.603-.233-2.824-.645-4.96-2.257-6.404-4.837a12.681 12.681 0 0 1-1.635-5.438c0-.934.145-1.779.434-2.535.712-2.869 2.257-5.015 4.637-6.438zm5.77-4.404c-2.557 0-4.914.679-7.071 2.035-3.047 1.935-5.049 4.682-6.005 8.24-.089.489-.234 1.556-.434 3.202 0 1.668.334 3.28 1.001 4.837.222.756.534 1.435.934 2.035 1.913 3.136 4.659 5.126 8.24 5.972 1.09.4 2.157.545 3.202.433 2.49 0 4.782-.6 6.872-1.801 3.136-2.068 5.137-4.815 6.005-8.24.378-1.423.523-2.502.433-3.236 0-2.49-.577-4.837-1.734-7.038-2.024-3.136-4.77-5.138-8.24-6.005a36.187 36.187 0 0 0-3.202-.434z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.53 233.06c2.391-.863 4.528-1.293 6.41-1.293 7.802.353 13.211 4.117 16.23 11.291 3.058 10.351-.255 17.936-9.938 22.759-2.234.862-4.371 1.293-6.409 1.293-7.606-.313-13.134-4.116-16.583-11.408-2.745-10.469.686-18.016 10.29-22.642z",
    fill: "url(#i)",
    transform: "translate(20.028 -13.257) scale(.66718)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.814 141.369c1.516-.55 3.06-.824 4.63-.824 5.466.21 9.429 2.877 11.887 8.004.576 1.726.863 3.269.863 4.63-.235 5.571-2.916 9.533-8.042 11.887-1.544.653-3.087.942-4.63.863-5.467-.104-9.43-2.786-11.888-8.043-.654-1.57-.928-3.1-.824-4.59.21-5.466 2.877-9.442 8.004-11.927zm14.79 7.964c-2.118-4.368-5.48-6.657-10.083-6.866-1.412 0-2.694.21-3.845.628-4.446 2.014-6.735 5.375-6.866 10.083 0 1.23.223 2.512.667 3.846 2.014 4.341 5.362 6.63 10.044 6.866 1.203 0 2.498-.21 3.884-.628 4.342-2.015 6.63-5.375 6.866-10.083a11.64 11.64 0 0 0-.667-3.846z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "m431.3 231.95 45.9 70.95-106.65 41.75L356.6 261z",
    transform: "translate(20.028 -13.257) scale(.66718)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337.005 188.532-29.79-45.736-48.103 18.615 8.907 53.674zm-80.128-27.422-.234-.867.868-.2 49.705-19.315.633-.4.668.834 30.823 47.135.668 1.202-72.756 28.055-.968.634z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.509 176.522c-.512-.29-1.09-.322-1.735-.1-.778.312-1.167.924-1.167 1.835 0 .29.066.823.2 1.601.2.445.489.878.867 1.301.623.69 1.335.856 2.135.5a1.9 1.9 0 0 0 1.201-1.167c.178-.512.112-1.257-.2-2.236-.422-.866-.856-1.444-1.301-1.734zm-.3-2.902 2.335-.933 3.302 8.54c.49 1.09.668 2.057.534 2.902-.311 1.334-1.412 2.369-3.302 3.102-1.18.445-2.18.556-3.003.334-1-.222-1.723-.757-2.168-1.601l2.602-.967c.089.355.255.534.5.534.267.066.746 0 1.435-.2.867-.312 1.357-.812 1.468-1.502 0-.534-.145-1.179-.434-1.935l-.167-.533a2.723 2.723 0 0 1-.567 1.167c-.312.556-.845.99-1.601 1.301-1.134.49-2.213.445-3.236-.133-1.045-.69-1.823-1.68-2.335-2.97-.556-1.29-.667-2.545-.334-3.769.29-1.09 1.079-1.912 2.369-2.468.578-.2 1.012-.3 1.3-.3.624 0 1.224.244 1.802.734zm-16.513 2.902 2.335-.934 2.602 6.639 1.368-4.504 2.769-1.2-1.702 4.636 5.471 4.37-2.769 1.1-3.67-3.035-.533 1.402 1.168 2.801-2.335.934zM294.773 163.612c.4 1.202.545 2.236.433 3.103-.089.867-.389 1.59-.9 2.168-.49.578-1.157 1-2.002 1.268-.8.266-1.59.322-2.368.167-.734-.179-1.401-.59-2.002-1.235s-1.1-1.568-1.501-2.769l-.7-2.168c-.4-1.201-.545-2.236-.434-3.102.089-.868.4-1.59.934-2.169.489-.555 1.145-.967 1.968-1.234s1.613-.322 2.368-.167c.734.156 1.402.556 2.002 1.201s1.1 1.568 1.501 2.768zm-6.872-2.335c0 .445.1 1.001.3 1.668l.934 2.87c.222.689.467 1.211.734 1.568.267.355.544.59.834.7.289.068.589.056.9-.033.334-.112.59-.29.768-.534.178-.245.255-.59.233-1.034 0-.423-.111-.979-.333-1.668l-.934-2.87c-.2-.667-.434-1.19-.7-1.567-.246-.356-.513-.568-.801-.634-.29-.111-.6-.111-.934 0-.334.111-.579.29-.734.534-.2.222-.29.556-.267 1zm-6.238-1.334 3.97 12.176-2.603.868-2.969-9.107-2.568 1.768-.667-2.102 4.57-3.502z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.148 78.213c1.023 0 2.091.112 3.203.334 3.78 1.09 6.75 3.314 8.907 6.672 2.024 3.424 2.569 7.06 1.634 10.908-.867 3.758-3.013 6.727-6.437 8.907-2.447 1.401-4.927 2.102-7.44 2.102-1.067 0-2.234-.167-3.502-.5-3.914-.846-6.95-2.992-9.106-6.439-.356-.912-.69-1.657-1.001-2.235-1.046-2.78-1.257-5.682-.634-8.707.957-3.847 3.17-6.805 6.638-8.873 2.401-1.446 4.981-2.169 7.738-2.169zm7.906 9.441c-1.356-2.224-3.313-3.714-5.87-4.47-1.001-.156-1.746-.234-2.236-.234a9.682 9.682 0 0 0-5.071 1.401c-2.268 1.513-3.725 3.47-4.37 5.872-.645 2.78-.256 5.214 1.168 7.305 1.467 2.247 3.425 3.714 5.87 4.404 1.046.2 1.87.3 2.47.3 1.867 0 3.48-.434 4.836-1.301 2.313-1.379 3.781-3.37 4.404-5.971.623-2.469.223-4.904-1.2-7.306z",
    fill: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.015 84.051c-1.735 0-3.191.39-4.37 1.168-2.068 1.378-3.413 3.19-4.036 5.437-.267.6-.356 1.28-.267 2.035 0 1.668.4 3.136 1.2 4.404 1.18 1.934 2.992 3.213 5.438 3.836.89.178 1.568.267 2.035.267 1.534 0 3.002-.412 4.404-1.235 1.934-1.245 3.236-2.98 3.903-5.204.111-1.112.167-1.8.167-2.068 0-1.69-.39-3.146-1.168-4.37-1.112-2.068-2.857-3.436-5.237-4.103-.845-.2-1.535-.256-2.069-.167zm-5.638-.433c1.758-1.09 3.636-1.635 5.638-1.635.957 0 1.78.145 2.469.434 2.758.511 4.97 2.046 6.638 4.603 1.045 1.958 1.523 3.848 1.434 5.671 0 .512-.078 1.346-.234 2.502-.778 2.914-2.379 5.115-4.803 6.605-1.89.956-3.747 1.39-5.571 1.301-.579 0-1.446-.078-2.602-.233-2.825-.645-4.96-2.257-6.405-4.837a12.672 12.672 0 0 1-1.635-5.438c0-.934.145-1.78.434-2.535.712-2.87 2.257-5.015 4.637-6.438zm5.771-4.404c-2.557 0-4.914.679-7.072 2.035-3.047 1.935-5.048 4.682-6.004 8.24-.09.489-.234 1.556-.434 3.202 0 1.668.334 3.28 1 4.837.223.756.535 1.435.935 2.035 1.912 3.136 4.659 5.126 8.24 5.971 1.09.4 2.157.545 3.202.434 2.49 0 4.782-.6 6.872-1.801 3.136-2.069 5.137-4.815 6.005-8.24.378-1.423.523-2.502.433-3.236 0-2.49-.578-4.837-1.734-7.039-2.024-3.135-4.77-5.137-8.24-6.004a36.136 36.136 0 0 0-3.203-.434zm-8.173.2c2.491-1.49 5.171-2.235 8.04-2.235 2.002.2 3.225.345 3.67.434 4.18 1.2 7.316 3.547 9.407 7.039 1.6 2.468 2.358 5.148 2.268 8.04 0 1.378-.145 2.601-.433 3.669-1.045 4.047-3.436 7.227-7.172 9.54-2.357 1.624-4.96 2.369-7.806 2.235-1.29 0-2.58-.144-3.87-.433-3.936-1.045-7.083-3.403-9.44-7.072l-1.168-2.469c-.512-1.668-.834-3.491-.967-5.47.178-1.735.322-2.948.433-3.637 1.09-4.158 3.436-7.372 7.038-9.64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.48 165.06c2.392-.863 4.528-1.293 6.41-1.293 7.802.353 13.211 4.117 16.23 11.291 3.058 10.351-.255 17.936-9.938 22.758-2.234.863-4.371 1.293-6.41 1.293-7.605-.313-13.134-4.117-16.583-11.409-2.744-10.467.687-18.014 10.291-22.64z",
    fill: "url(#g)",
    transform: "translate(20.028 -13.257) scale(.66718)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.994 103.967c-2.118-4.37-5.479-6.658-10.082-6.866-1.413 0-2.695.208-3.846.627-4.446 2.014-6.735 5.375-6.866 10.083 0 1.23.223 2.512.667 3.845 2.014 4.342 5.362 6.63 10.045 6.866 1.202 0 2.497-.208 3.883-.627 4.342-2.015 6.63-5.376 6.866-10.084 0-1.281-.222-2.563-.667-3.844zm-14.79-7.965c1.516-.55 3.06-.824 4.628-.824 5.467.21 9.43 2.877 11.888 8.005.575 1.725.863 3.268.863 4.628-.236 5.572-2.916 9.534-8.043 11.888-1.543.653-3.087.942-4.63.863-5.465-.104-9.43-2.786-11.887-8.043-.654-1.57-.929-3.1-.824-4.59.209-5.466 2.877-9.442 8.004-11.927z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "m604.25 163.95 45.9 70.95-106.65 41.75L529.55 193z",
    transform: "translate(20.028 -13.257) scale(.66718)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m452.394 143.163-29.79-45.735-48.103 18.614 8.907 53.675zm-80.128-27.42-.234-.868.868-.2 49.704-19.315.634-.4.667.834 30.823 47.136.668 1.2-72.756 28.056-.968.634z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.199 132.889c-.423-.868-.856-1.446-1.301-1.735-.512-.29-1.09-.322-1.735-.1-.779.312-1.168.923-1.168 1.835 0 .29.067.822.2 1.601.2.445.49.878.868 1.301.623.69 1.334.856 2.135.5.578-.2.979-.589 1.2-1.167.179-.512.112-1.256-.2-2.235zm-4.204-3.77c.579-.2 1.013-.3 1.301-.3.624 0 1.223.245 1.802.734l-.5-1.301 2.335-.934 3.301 8.54c.49 1.09.668 2.057.535 2.902-.312 1.334-1.413 2.368-3.303 3.102-1.179.445-2.18.556-3.002.334-1-.222-1.723-.756-2.168-1.601l2.601-.968c.09.356.256.534.5.534.267.067.746 0 1.435-.2.867-.312 1.356-.812 1.468-1.501 0-.534-.145-1.18-.434-1.935l-.167-.534a2.72 2.72 0 0 1-.567 1.168c-.311.555-.845.99-1.601 1.3-1.134.49-2.213.446-3.236-.133-1.045-.69-1.823-1.679-2.335-2.969-.556-1.29-.667-2.546-.334-3.77.29-1.089 1.08-1.912 2.37-2.468zm-13.91 2.035 2.335-.934 2.601 6.638 1.368-4.503 2.769-1.2-1.702 4.636 5.471 4.37-2.768 1.1-3.67-3.035-.534 1.401 1.168 2.802-2.335.935zM401.622 113.507c.489-.556 1.145-.967 1.968-1.234.822-.267 1.612-.322 2.368-.167.734.156 1.401.556 2.002 1.201.6.645 1.1 1.568 1.501 2.769l.7 2.168c.4 1.201.545 2.235.434 3.103-.09.867-.39 1.59-.901 2.168-.49.578-1.156 1-2.002 1.268-.8.266-1.59.322-2.368.166-.734-.178-1.401-.589-2.002-1.234-.6-.644-1.1-1.568-1.5-2.769l-.701-2.168c-.401-1.201-.545-2.235-.434-3.102.09-.868.4-1.59.935-2.169zm-8.74 6.772-.668-2.102 4.571-3.502.266-.1 3.97 12.176-2.601.867-2.97-9.107zm10.408-4.37c0 .445.099 1 .3 1.668l.933 2.869c.222.69.467 1.212.735 1.568.266.355.544.589.834.7.289.067.589.056.9-.033.334-.111.59-.289.768-.534s.255-.589.233-1.034c0-.422-.111-.979-.333-1.668l-.934-2.869c-.2-.667-.433-1.19-.701-1.568-.244-.355-.512-.567-.8-.633-.29-.112-.6-.112-.934 0s-.578.29-.735.533c-.2.222-.288.556-.266 1.001z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.11 42.953c-1.357-2.224-3.314-3.714-5.871-4.47-1.001-.156-1.747-.234-2.236-.234a9.68 9.68 0 0 0-5.07 1.401c-2.269 1.513-3.726 3.47-4.37 5.872-.646 2.78-.257 5.214 1.167 7.305 1.468 2.247 3.424 3.714 5.87 4.404 1.046.2 1.869.3 2.47.3 1.868 0 3.48-.434 4.837-1.301 2.313-1.379 3.78-3.37 4.403-5.971.623-2.469.223-4.904-1.2-7.306zm-7.906-9.44c1.022 0 2.09.11 3.202.333 3.781 1.09 6.75 3.314 8.907 6.672 2.023 3.424 2.57 7.06 1.635 10.908-.868 3.758-3.014 6.727-6.438 8.907-2.447 1.401-4.927 2.102-7.44 2.102-1.067 0-2.234-.167-3.502-.5-3.914-.846-6.95-2.992-9.107-6.44-.355-.911-.69-1.656-1-2.234-1.045-2.78-1.257-5.683-.634-8.707.956-3.847 3.17-6.805 6.638-8.873 2.401-1.446 4.98-2.169 7.739-2.169z",
    fill: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.432 38.916c1.758-1.089 3.637-1.634 5.638-1.634.957 0 1.78.145 2.469.434 2.757.511 4.97 2.046 6.638 4.603 1.045 1.958 1.523 3.848 1.434 5.671 0 .512-.077 1.346-.234 2.502-.778 2.914-2.38 5.115-4.803 6.605-1.89.956-3.748 1.39-5.571 1.301-.579 0-1.446-.078-2.602-.233-2.824-.645-4.96-2.257-6.405-4.837a12.672 12.672 0 0 1-1.635-5.438c0-.934.145-1.78.433-2.535.713-2.87 2.259-5.015 4.638-6.439zm5.772-4.403c-2.558 0-4.916.679-7.073 2.035-3.047 1.935-5.048 4.682-6.005 8.24-.089.489-.233 1.556-.433 3.202 0 1.668.334 3.28 1.001 4.837.222.756.534 1.435.933 2.035 1.913 3.136 4.66 5.126 8.24 5.971 1.09.4 2.158.545 3.203.434 2.49 0 4.782-.6 6.872-1.801 3.136-2.069 5.137-4.815 6.005-8.24.377-1.423.522-2.502.433-3.236 0-2.49-.578-4.837-1.735-7.039-2.023-3.135-4.77-5.137-8.24-6.004a36.17 36.17 0 0 0-3.201-.434zm-8.173.2c2.49-1.49 5.17-2.235 8.04-2.235 2 .2 3.224.345 3.669.434 4.18 1.2 7.317 3.547 9.407 7.039 1.601 2.468 2.357 5.148 2.268 8.04 0 1.378-.144 2.601-.433 3.669-1.045 4.047-3.436 7.227-7.173 9.54-2.357 1.624-4.959 2.369-7.805 2.235-1.29 0-2.58-.144-3.87-.433-3.936-1.045-7.083-3.403-9.44-7.072l-1.168-2.469c-.511-1.668-.834-3.491-.967-5.47.178-1.736.322-2.948.434-3.637 1.088-4.159 3.435-7.372 7.038-9.64zm8.04 4.637c-1.735 0-3.192.39-4.37 1.168-2.07 1.378-3.415 3.19-4.037 5.437-.267.6-.357 1.28-.267 2.035 0 1.668.4 3.136 1.2 4.404 1.18 1.934 2.992 3.213 5.438 3.836.89.178 1.568.267 2.035.267 1.535 0 3.002-.412 4.404-1.235 1.934-1.245 3.236-2.98 3.903-5.204.111-1.112.167-1.801.167-2.068 0-1.69-.39-3.146-1.168-4.37-1.112-2.068-2.857-3.436-5.238-4.103-.845-.2-1.534-.256-2.068-.167z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.93 98.058c2.391-.863 4.527-1.293 6.409-1.293 7.802.353 13.212 4.117 16.23 11.291 3.059 10.351-.255 17.936-9.938 22.758-2.234.863-4.37 1.293-6.409 1.293-7.605-.313-13.134-4.117-16.583-11.409-2.745-10.467.685-18.014 10.291-22.64z",
    fill: "url(#e)",
    transform: "translate(20.028 -13.257) scale(.66718)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.258 51.302c1.516-.55 3.06-.823 4.63-.823 5.466.209 9.429 2.877 11.887 8.004.575 1.725.863 3.268.863 4.629-.236 5.571-2.916 9.534-8.043 11.888-1.543.653-3.086.942-4.63.862-5.466-.104-9.429-2.785-11.887-8.043-.654-1.57-.93-3.1-.824-4.59.21-5.466 2.878-9.442 8.004-11.927zm14.791 7.965c-2.119-4.369-5.48-6.657-10.083-6.866-1.412 0-2.694.209-3.845.628-4.447 2.013-6.735 5.374-6.866 10.083 0 1.229.222 2.511.667 3.845 2.015 4.342 5.362 6.63 10.044 6.866 1.204 0 2.498-.21 3.884-.628 4.342-2.015 6.63-5.376 6.866-10.083 0-1.282-.223-2.564-.667-3.845z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "m776.7 96.95 45.9 70.95-106.65 41.75L702 126z",
    transform: "translate(20.028 -13.257) scale(.66718)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m567.45 98.462-29.79-45.735-48.104 18.614 8.907 53.675zm-80.13-27.42-.233-.868.867-.2 49.705-19.315.634-.4.667.834 30.824 47.136.668 1.2-72.756 28.056-.968.633z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.05 88.188c0 .29.067.822.2 1.601.201.445.49.878.868 1.301.623.69 1.335.856 2.135.5.578-.2.979-.589 1.201-1.167.178-.512.111-1.257-.2-2.235-.423-.868-.856-1.446-1.301-1.735-.512-.29-1.09-.322-1.735-.1-.778.312-1.167.923-1.167 1.835zm2.603-4.637 2.335-.934 3.302 8.54c.49 1.09.668 2.057.534 2.902-.311 1.334-1.412 2.368-3.302 3.102-1.18.445-2.18.556-3.002.334-1-.222-1.724-.756-2.168-1.601l2.6-.968c.09.356.257.534.501.534.267.067.746 0 1.435-.2.867-.312 1.356-.812 1.468-1.501 0-.534-.145-1.18-.434-1.935l-.167-.534c-.09.422-.278.811-.567 1.168-.312.555-.846.99-1.601 1.3-1.134.49-2.213.446-3.236-.133-1.046-.69-1.824-1.68-2.335-2.969-.557-1.29-.667-2.546-.334-3.77.29-1.089 1.078-1.912 2.369-2.468.577-.2 1.012-.3 1.3-.3.623 0 1.224.245 1.801.734zm-16.513 2.902 2.335-.934 2.602 6.638 1.368-4.503 2.769-1.2-1.702 4.636 5.47 4.37-2.768 1.1-3.67-3.035-.533 1.401 1.168 2.802-2.335.934zM524.75 78.814c-.49.578-1.157 1-2.002 1.267-.8.267-1.59.323-2.368.167-.735-.178-1.402-.589-2.002-1.234-.6-.645-1.1-1.568-1.501-2.769l-.7-2.168c-.402-1.201-.546-2.235-.434-3.103.088-.867.4-1.59.934-2.168.488-.556 1.145-.967 1.967-1.234.823-.267 1.613-.322 2.37-.167.733.156 1.4.556 2.001 1.201.6.644 1.1 1.568 1.501 2.769l.7 2.168c.401 1.201.545 2.235.434 3.103-.088.867-.389 1.59-.9 2.168zm-5.404-9.14c-.334.11-.579.289-.735.533-.2.222-.289.556-.266 1.001 0 .445.1 1 .3 1.668l.933 2.869c.223.689.467 1.212.734 1.568s.545.589.834.7c.29.067.59.056.902-.033.333-.112.589-.289.766-.534.179-.245.256-.589.234-1.034 0-.422-.111-.979-.333-1.668l-.934-2.869c-.2-.667-.433-1.19-.7-1.568-.246-.355-.513-.567-.801-.634-.29-.11-.6-.11-.934 0zm-7.24.2 3.97 12.176-2.602.867-2.968-9.107-2.57 1.768-.666-2.102 4.57-3.502z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.05 332.9c4.233 4.233 6.35 9.35 6.35 15.35 0 5.967-2.117 11.066-6.35 15.3s-9.35 6.351-15.35 6.351c-5.967 0-11.067-2.117-15.3-6.351s-6.35-9.333-6.35-15.3c0-6 2.117-11.116 6.35-15.35s9.333-6.351 15.3-6.351c6 .001 11.116 2.118 15.35 6.351z",
    fill: "url(#c)",
    transform: "translate(20.028 -13.257) scale(.66718)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.924 208.847c2.824 2.824 4.237 6.238 4.237 10.241 0 3.981-1.413 7.383-4.237 10.208s-6.238 4.238-10.241 4.238c-3.981 0-7.384-1.413-10.208-4.238s-4.237-6.227-4.237-10.208c0-4.003 1.413-7.416 4.237-10.24s6.227-4.238 10.208-4.238c4.003 0 7.416 1.413 10.241 4.237z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 3,
    strokeWidth: 2.00154
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499 287.4c4.233 4.233 6.35 9.35 6.35 15.35 0 5.967-2.117 11.066-6.35 15.3s-9.35 6.351-15.35 6.351c-5.966 0-11.066-2.117-15.3-6.351s-6.35-9.333-6.35-15.3c0-6 2.117-11.116 6.35-15.35s9.333-6.351 15.3-6.351c6 .001 11.117 2.118 15.35 6.351z",
    fill: "url(#b)",
    transform: "translate(20.028 -13.257) scale(.66718)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.95 178.49c2.825 2.825 4.237 6.239 4.237 10.242 0 3.98-1.412 7.383-4.236 10.208s-6.238 4.237-10.241 4.237c-3.98 0-7.383-1.413-10.208-4.237s-4.237-6.227-4.237-10.208c0-4.003 1.413-7.417 4.237-10.241s6.227-4.238 10.208-4.238c4.003 0 7.417 1.413 10.24 4.238z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 3,
    strokeWidth: 2.00154
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M495.05 303.95 359.2 356.8l-3.85-9.35 135.85-52.9z",
    transform: "translate(20.028 -13.257) scale(.66718)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 3,
    strokeWidth: 2.00154,
    d: "m350.315 189.532-90.636 35.26-2.569-6.237 90.637-35.294z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.35 280.25c0 5.967-2.116 11.066-6.35 15.3s-9.35 6.351-15.35 6.351c-5.967 0-11.067-2.117-15.301-6.351s-6.35-9.333-6.35-15.3c0-6 2.116-11.116 6.35-15.35s9.334-6.351 15.301-6.351c6 0 11.116 2.117 15.35 6.351s6.35 9.35 6.35 15.35z",
    fill: "url(#o)",
    transform: "translate(20.028 -13.257) scale(.66718)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.55 173.72c0 3.981-1.412 7.383-4.237 10.208s-6.238 4.237-10.241 4.237c-3.981 0-7.384-1.412-10.209-4.237s-4.236-6.227-4.236-10.208c0-4.003 1.411-7.416 4.236-10.241s6.228-4.237 10.209-4.237c4.003 0 7.416 1.412 10.24 4.237s4.237 6.238 4.237 10.241z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 3,
    strokeWidth: 2.00154
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.6 213.05c6 0 11.117 2.117 15.351 6.35s6.35 9.35 6.35 15.35c0 5.967-2.116 11.067-6.35 15.3-4.233 4.233-9.351 6.351-15.351 6.351-5.967 0-11.066-2.117-15.3-6.351-4.233-4.233-6.35-9.333-6.35-15.3 0-6 2.116-11.117 6.35-15.35s9.333-6.35 15.3-6.35z",
    fill: "url(#n)",
    transform: "translate(20.028 -13.257) scale(.66718)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.098 128.886c4.003 0 7.417 1.412 10.242 4.236s4.237 6.238 4.237 10.242c0 3.98-1.412 7.383-4.237 10.207-2.824 2.825-6.239 4.238-10.242 4.238-3.98 0-7.383-1.413-10.207-4.238-2.825-2.824-4.237-6.226-4.237-10.207 0-4.004 1.412-7.418 4.237-10.242s6.226-4.236 10.207-4.236z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 3,
    strokeWidth: 2.00154
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M668 235.95 532.15 288.8l-3.85-9.35 135.85-52.9z",
    transform: "translate(20.028 -13.257) scale(.66718)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 3,
    strokeWidth: 2.00154,
    d: "m465.704 144.164-90.636 35.26-2.569-6.238 90.637-35.293z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M712.1 191.55c6 0 11.117 2.117 15.351 6.35s6.35 9.35 6.35 15.35c0 5.967-2.116 11.067-6.35 15.3-4.233 4.233-9.351 6.35-15.351 6.35-5.967 0-11.066-2.117-15.3-6.35-4.233-4.233-6.35-9.333-6.35-15.3 0-6 2.116-11.117 6.35-15.35s9.333-6.35 15.3-6.35z",
    fill: "url(#l)",
    transform: "translate(20.028 -13.257) scale(.66718)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.127 114.541c4.003 0 7.417 1.413 10.242 4.237s4.236 6.238 4.236 10.241c0 3.981-1.411 7.384-4.236 10.208-2.824 2.824-6.239 4.237-10.242 4.237-3.981 0-7.383-1.413-10.208-4.237-2.824-2.824-4.237-6.227-4.237-10.208 0-4.003 1.412-7.417 4.237-10.241s6.227-4.237 10.208-4.237z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 3,
    strokeWidth: 2.00154
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M807.4 167.75c0-6 2.116-11.117 6.35-15.35s9.333-6.35 15.3-6.35c6 0 11.117 2.117 15.351 6.35 4.232 4.233 6.35 9.35 6.35 15.35 0 5.967-2.117 11.067-6.35 15.3s-9.351 6.35-15.351 6.35c-5.967 0-11.066-2.117-15.3-6.35-4.233-4.233-6.35-9.333-6.35-15.3z",
    fill: "url(#k)",
    transform: "translate(20.028 -13.257) scale(.66718)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.71 98.662c0-4.003 1.41-7.417 4.236-10.24s6.227-4.237 10.208-4.237c4.003 0 7.417 1.412 10.241 4.236s4.237 6.238 4.237 10.241c0 3.982-1.412 7.384-4.237 10.208s-6.238 4.237-10.241 4.237c-3.981 0-7.383-1.413-10.208-4.237-2.824-2.824-4.237-6.226-4.237-10.208z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 3,
    strokeWidth: 2.00154
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "m700.75 212.45 135.85-52.9 3.85 9.4L704.6 221.8z",
    transform: "translate(20.028 -13.257) scale(.66718)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 3,
    strokeWidth: 2.00154,
    d: "m487.554 128.485 90.637-35.293 2.568 6.271-90.636 35.26z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem10C);
export default __webpack_public_path__ + "static/media/item10c.22417b7a248c86fc6640365889a7cc3d.svg";
export { ForwardRef as ReactComponent };